/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Exact_Alarm_BodyInputs */

const en_us2_offline_exact_alarm_body = /** @type {(inputs: Offline_Exact_Alarm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow exact alarms so it rings on time with the screen off.`)
};

const pt_br2_offline_exact_alarm_body = /** @type {(inputs: Offline_Exact_Alarm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permita alarmes exatos para ele tocar na hora, mesmo com a tela apagada.`)
};

const es_419_offline_exact_alarm_body = /** @type {(inputs: Offline_Exact_Alarm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permite las alarmas exactas para que suene a tiempo, incluso con la pantalla apagada.`)
};

const pt_pt2_offline_exact_alarm_body = /** @type {(inputs: Offline_Exact_Alarm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permite alarmes exatos para que toque à hora certa, mesmo com o ecrã desligado.`)
};

const fr_fr2_offline_exact_alarm_body = /** @type {(inputs: Offline_Exact_Alarm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorise les alarmes exactes pour qu'elle sonne à l'heure, même écran éteint.`)
};

const de_de2_offline_exact_alarm_body = /** @type {(inputs: Offline_Exact_Alarm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlaube exakte Alarme, damit er auch bei ausgeschaltetem Bildschirm pünktlich klingelt.`)
};

const it_it2_offline_exact_alarm_body = /** @type {(inputs: Offline_Exact_Alarm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consenti le sveglie esatte perché suoni in tempo anche a schermo spento.`)
};

/**
* | output |
* | --- |
* | "Allow exact alarms so it rings on time with the screen off." |
*
* @param {Offline_Exact_Alarm_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_exact_alarm_body = /** @type {((inputs?: Offline_Exact_Alarm_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Exact_Alarm_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_exact_alarm_body(inputs)
	if (locale === "es-419") return es_419_offline_exact_alarm_body(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_exact_alarm_body(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_exact_alarm_body(inputs)
	if (locale === "de-DE") return de_de2_offline_exact_alarm_body(inputs)
	if (locale === "it-IT") return it_it2_offline_exact_alarm_body(inputs)
	return en_us2_offline_exact_alarm_body(inputs)
});
export { offline_exact_alarm_body as "offline.exact_alarm_body" }